import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import type { BackofficeJobSearchQuery } from "../../lib/jobSearch/getBackofficeJobSearchQuery"

export function useRetryBackofficeJobsMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (query: BackofficeJobSearchQuery) => {
      const { data } = await axios.post<{ data: { retried: number } }>(
        "/backoffice/jobSearch/retry",
        null,
        { params: query },
      )
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["backofficeJobSearch"] })
    },
  })
}
